import { OPTIONS } from './consts';
export default {
  data() {
    return {
      OPTIONS,
      qrcodeImg: require('./images/qrcode.png'),
      badgeUrl: require('./images/badge.png')
    };
  }
};